import {combineReducers} from "redux";

import {reduceResponseField} from "@pg-mono/request-state";

import {fetchTestimonialsTypes} from "../api/fetch_testimonials";
import {ITestimonial} from "../types/ITestimonial";

export interface ITestimonialsStore {
    list: ITestimonial[];
}

export const testimonialsReducer = combineReducers({
    list: reduceResponseField<ITestimonial[]>(fetchTestimonialsTypes, "results", [])
});
